/**
 * A room's ratings (feedback) setting as the dashboards show it: follow the default (the tenant's in the cloud, the
 * processor's in device mode), or its own on/off. Stored as a nullable boolean override.
 */
export type RoomFeedbackChoice = 'inherit' | 'on' | 'off';

export function feedbackChoice(override: boolean | null | undefined): RoomFeedbackChoice {
    return override == null ? 'inherit' : override ? 'on' : 'off';
}

export function feedbackOverride(choice: RoomFeedbackChoice): boolean | null {
    return choice === 'inherit' ? null : choice === 'on';
}
